module.exports = __webpack_public_path__ + "static/media/majorC5.ab30464.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC5.wav
// module id = KQ7j
// module chunks = 0